import React from 'react';
import { useNavigate } from 'react-router-dom';
import background from '../assets/background.png';
import './Home.css';

export default function Home() {
  const navigate = useNavigate();

  return (
    <main
      className="home-container"
      style={{ '--home-bg': `url(${background})` }}
    >
      {/* Marcações de campo desenhadas em linha, só decoração */}
      <svg
        className="home-pitch"
        viewBox="0 0 600 800"
        fill="none"
        aria-hidden="true"
        focusable="false"
      >
        <rect x="20" y="20" width="560" height="760" rx="6" pathLength="1" />
        <line x1="20" y1="400" x2="580" y2="400" pathLength="1" />
        <circle cx="300" cy="400" r="95" pathLength="1" />
        <circle cx="300" cy="400" r="5" className="home-pitch-dot" />
        <rect x="150" y="20" width="300" height="130" pathLength="1" />
        <rect x="150" y="650" width="300" height="130" pathLength="1" />
      </svg>

      <section className="home-content">
        <h1 className="home-title">
          Crie seu campeonato de futebol agora mesmo!
        </h1>
        <p className="subtitle">O futebol amador é aqui.</p>
        <p className="home-description">
          Chega de planilhas confusas. Crie, organize e acompanhe seu
          campeonato em tempo real: tabela, mata-mata, artilharia, súmulas e
          escalações em um só lugar.
        </p>
        <button
          type="button"
          className="start-button"
          onClick={() => navigate('/login')}
        >
          Criar meu campeonato
        </button>
      </section>
    </main>
  );
}
